export default __webpack_public_path__ + "static/media/nimbusAidProject.ab50117b.jpg";